import { Box, Container, useMediaQuery, Grid } from '@mui/material';
import React, { useContext, useState, useEffect, useCallback, useRef } from 'react';
import { useApolloClient } from '@apollo/client';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRightRounded';
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { getCookie } from '../../hooks/useCookie';
import SwiperCarousel from '../shared/SwiperCarousel';
import styles from './style';
import EirOfferCard from '../eir-offer-card/EirOfferCard';
// import EirInformation from '../eir-information/EirInformation';
import { addMbbTariffs, removeMbbTariffs, onload } from './Mbb.util';
import RootContext from '../../../util/root.context';
import { displayCart } from '../eir-cart/cart.util';
import useLocalStorage from '../../hooks/useLocalStorage';
import useMaxHeightCard from '../eir-offer-card/offer-cart.util';
import EirSingleOfferCard from '../eir-offer-card/EirSingleOfferCard';
import { addToCartAnalytics, removeFromCartAnalytics } from '../../../util/gtm';
import { formatAfterPrice } from '../../../util/Format.util';
import { useToggle } from '../../hooks/useToggle';
import ErrorModal from '../eir-error-modal/ErrorModal';
import ApiFailureModal from '../eir-error-modal/ApiFailureModal';
import LoginMain403 from '../eir-403-login/LoginMain403';
import SessionExpireModal from '../eir-session-expire-modal/sessionExpireModal';

const { publicRuntimeConfig } = getConfig();

const MbbOfferCardContainer = ({
  setShowMbbDevice,
  setOfferCode,
  setSelectedAddOnCode,
  showOnBroadband,
  cmsData,
  simOnly,
}) => {
  const [broadbandData, setBroadbandData] = useState();
  const [offerSelected, setOfferSelected] = useState(null);
  const [leftArrowDisabled, setLeftArrowDisabled] = useState(true);
  const [RightArrowDisabled, setRightArrowDisabled] = useState(false);
  const openAPIFailureModal = useToggle(false);
  const [openError, setOpenError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const [onLoadError, setOnLoadError] = useState(false);
  const [loading, setLoading] = useState(true);
  const errorModalMaxOccurence = 1;
  const errorBBModal = useToggle(false);
  const localStore = useLocalStorage();
  const router = useRouter();
  const graphql = useApolloClient();
  const { state: rootState, dispatch } = useContext(RootContext);
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
    } else {
      showSessionExpiredModal.disable();
    }
  });
  const nextStep = () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband/current-service`);
  };
  const handleOk = () => {
    openAPIFailureModal.disable();
  };
  const theme = useTheme();
  const style = styles(theme);
  const swiperRef = useRef(null);
  const md = useMediaQuery(theme.breakpoints.down('md'));
  const xs = useMediaQuery(theme.breakpoints.down('sm'));
  const [showLoader, setShowLoader] = useState(' ');

  const broadbandOnload = async () => {
    const { selectedMbbOffer, offers, cartData, selectedMbbAddOn } = await onload({
      localStorage: localStore,
      graphql,
      dispatch,
      showOnBroadband,
    });
    // set offers
    if (offers) {
      const offersData = offers?.map(offer => formatAfterPrice(offer, simOnly));
      setBroadbandData(offersData);
      setLoading(false);
    } else {
      setOnLoadError(true);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorBBModal.enable();
      if (!getCookie('token-missing')) errorBBModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
    }
    // set selected offer and set Tv
    if (selectedMbbOffer) {
      setOfferSelected(selectedMbbOffer);
      setShowMbbDevice(true);
      dispatch({ type: 'SET_CART', payload: cartData });
      setSelectedAddOnCode(selectedMbbAddOn[0]?.catalogCode);
      displayCart({
        dispatch,
        localStorage: localStore,
        graphql,
        cart: cartData,
        nextMethod: nextStep,
        disablenNextButton: false,
        showNextButton: false,
      });
    } else {
      setSelectedAddOnCode('');
      displayCart({
        dispatch,
        showCart: false,
      });
    }

    // setContractDuration(discountDuration);
  };

  /**
   * @name selectTariff - Function for adding selected tariff to the cart
   */
  const selectTariff = async (code, offerCode) => {
    setShowLoader(code);
    try {
      const data = await addMbbTariffs(graphql, code, offerCode, rootState.cart);
      if (data) {
        addToCartAnalytics(data);
        dispatch({ type: 'SET_CART', payload: data });
        displayCart({
          dispatch,
          localStorage: localStore,
          graphql,
          cart: data,
          nextMethod: nextStep,
          disablenNextButton: false,
          showNextButton: false,
        });
        setShowMbbDevice(true);
        setOfferCode(code);
        setOfferSelected(code);
        setShowLoader(' ');
        setErrorModalOccurence(0);
        errorBBModal.disable();
        setOnLoadError(false);
      } else {
        setOnLoadError(false);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorBBModal.enable();
        if (!getCookie('token-missing')) errorBBModal.enable();
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        setShowLoader(' ');
      }
    } catch (err) {
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorBBModal.enable();
      if (!getCookie('token-missing')) errorBBModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(' ');
      setShowMbbDevice(false);
      setOfferCode(' ');
    }
  };
  /**
   * @name removeTariffs - Function for removing selected tariff from the cart
   */
  const removeTariffs = async code => {
    setShowLoader(code);
    try {
      if (rootState.cart?.offers.length > 0) {
        // const offerId = await rootState.cart?.offers?.filter(
        //   offer => offer.baseOffer?.serviceGroup === 'MBB'
        // )[0]?.id;
        const offerId = await rootState.cart?.offers?.find(
          () => offer => offer.baseOffer?.serviceGroup === 'MBB'
        ).id;
        const data = await removeMbbTariffs(graphql, offerId);
        if (data != null && !data.error) {
          removeFromCartAnalytics(data);
          dispatch({ type: 'SET_CART', payload: data });
          displayCart({
            dispatch,
            localStorage: localStore,
            graphql,
            cart: data,
            disablenNextButton: true,
            showNextButton: false,
          });
          setShowMbbDevice(false);
          setOfferCode(' ');
          setOfferSelected(null);
          setShowLoader(' ');
          setErrorModalOccurence(0);
          errorBBModal.disable();
          setOnLoadError(false);
        } else {
          setOnLoadError(false);
          if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorBBModal.enable();
          if (!getCookie('token-missing')) errorBBModal.enable();
          if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
          setShowLoader(' ');
        }
      }
    } catch (err) {
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorBBModal.enable();
      if (!getCookie('token-missing')) errorBBModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(' ');
    }
  };

  const useMaxHeight = useMaxHeightCard();

  const handleLeftClick = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current.swiper.slidePrev();
  }, []);

  const handleRightClick = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current.swiper.slideNext();
  }, []);

  const checkArrowsStatus = () => {
    if (swiperRef.current.swiper.isBeginning) {
      setLeftArrowDisabled(true);
    }
    if (swiperRef.current.swiper.isEnd) {
      setRightArrowDisabled(true);
    }
    if (!swiperRef.current.swiper.isBeginning) {
      setLeftArrowDisabled(false);
    }
    if (!swiperRef.current.swiper.isEnd) {
      setRightArrowDisabled(false);
    }
  };
  const handleKeydown = e => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      e.target.click();
    }
  };

  const updatePaginationDots = swiper => {
    const paginationDots = swiper.el?.querySelectorAll('.swiper-pagination-bullet');
    if (!paginationDots || !paginationDots.length) return;

    const activeIndex = swiper.realIndex ?? swiper.activeIndex ?? 0;

    paginationDots.forEach((dot, i) => {
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');

      dot.removeEventListener('keydown', handleKeydown);
      dot.addEventListener('keydown', handleKeydown);

      if (i === activeIndex) {
        dot.setAttribute('aria-label', 'Current plan');
      } else if (i < activeIndex) {
        dot.setAttribute('aria-label', 'Previous plan');
      } else {
        dot.setAttribute('aria-label', 'Next plan');
      }
    });
  };

  useEffect(() => {
    checkArrowsStatus();
  }, [broadbandData]);
  useEffect(() => {
    broadbandOnload();
  }, []);
  return (
    <Container
      sx={{
        p: 0,
        mb: 2,
        display: { sm: 'flex', md: 'flex' },
        flexDirection: { sm: 'column', md: 'column' },
        alignItems: { sm: 'center', md: 'center' },
        justifyContent: { sm: 'center', md: 'center' },
        marginBottom: '0rem',
      }}
    >
      {/* <Box>
        <EirInformation
          // title={cmsDataImg.attributes?.EirInformation_MBB?.title}
          title='Mobile Broadband Plans'
          description=''
          style={{ title: styles(theme).title }}
        />
      </Box> */}
      <Box sx={styles(theme).offerCards} id='offerCardData'>
        {!md && broadbandData?.length > 3 && (
          <IconButton
            size='small'
            sx={styles(theme).prevArrow}
            onClick={handleLeftClick}
            disabled={leftArrowDisabled}
            disableRipple
            disableTouchRipple
          >
            <KeyboardArrowLeftIcon />
          </IconButton>
        )}
        <SwiperCarousel
          settings={{
            className: 'content-carousel-broadband',
            pagination: { enable: true, clickable: true },
            modules: [Pagination],
            initialSlide: 0,
            updateOnWindowResize: true,
            slidesPerView: 'auto',
            onSlideChange: swiper => {
              checkArrowsStatus();
              updatePaginationDots(swiper);
            },
            breakpoints: {
              320: {
                slidesPerView: 1,
              },
              600: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
            },
            onAfterInit: swiper => {
              setTimeout(() => {
                updatePaginationDots(swiper);
              }, 100);
            },
            onPaginationUpdate: swiper => {
              updatePaginationDots(swiper);
            },
            onBreakpoint: swiper => {
              updatePaginationDots(swiper);
            },
          }}
          sliderRef={swiperRef}
          style={style.offerSlider.swiper}
        >
          {loading
            ? Array(3)
                .fill()
                .map((_, index) => (
                  <SwiperSlide key={index}>
                    <EirOfferCard loading index={index} />
                  </SwiperSlide>
                ))
            : broadbandData &&
              broadbandData.length > 0 &&
              broadbandData.map(
                (offer, i) =>
                  ((broadbandData?.length > 0 && xs) || broadbandData.length > 1) && (
                    <SwiperSlide key={i} style={{ paddingBottom: '1rem' }}>
                      <EirOfferCard
                        slideNumber={i}
                        topTag={offer.topTag}
                        preTitle={offer.preTitle}
                        title={offer.title}
                        // headerImage={['test-broadband.svg']}
                        headerImage={offer.image}
                        headerImgDescription={offer.headerImgDescription}
                        headerImageActive={offer.imageActive ? offer.imageActive : ['']}
                        priceIncreaseTagline={offer.priceIncreaseTagline}
                        sash={offer.sash}
                        contractLength={offer.contractLength}
                        afterPrice={offer.afterPrice}
                        afterPricePosition={offer.afterPricePosition?.[0]}
                        price={offer.price}
                        noDiscount={offer.noDiscount}
                        description={offer.description}
                        descriptions={offer.descriptions}
                        discountDuration={offer.discountDuration}
                        selectButton={{
                          title: 'Select Offer',
                          action: () =>
                            offer.code === offerSelected
                              ? removeTariffs(offer.code)
                              : selectTariff(
                                  offer.code,
                                  offer.offerCode,
                                  offer.discountDuration,
                                  offer
                                ),
                        }}
                        offerSelected={offer.code === offerSelected}
                        promotion={offer.promotion}
                        moreInfo={offer.moreInfo}
                        useMaxHeight={useMaxHeight}
                        color='primary'
                        code={offer.code}
                        showLoader={showLoader}
                        isMbb
                        cmsData={cmsData}
                        loading={loading}
                      />
                    </SwiperSlide>
                  )
              )}
        </SwiperCarousel>
        {broadbandData &&
          (broadbandData.length > 0 ? (
            broadbandData.length === 1 &&
            !xs &&
            broadbandData.map((offer, i) => (
              <Grid key={i} item xs={12}>
                <EirSingleOfferCard
                  topTag={offer.topTag}
                  preTitle={offer.preTitle}
                  title={offer.title}
                  headerImage={offer.image}
                  headerImageActive={offer.imageActive ? offer.imageActive : ['']}
                  singleTariffHeaderImage={offer.singleTariffImage}
                  singleHeaderImgDescription={offer.singleHeaderImgDescription}
                  priceIncreaseTagline={offer.priceIncreaseTagline}
                  offerSelected={offer.code === offerSelected}
                  moreInfo={offer.moreInfo}
                  code={offer.code}
                  loading={loading}
                  sash={offer.sash}
                  description={offer.description}
                  descriptions={offer.descriptions}
                  price={offer.price}
                  contractLength={offer.contractLength}
                  afterPrice={offer.afterPrice}
                  noDiscount={offer.noDiscount}
                  index={i}
                  selectButton={{
                    title: 'Select offer',
                    action: () =>
                      offer.code === offerSelected
                        ? removeTariffs(offer.code)
                        : selectTariff(offer.code, offer.offerCode, offer.discountDuration, offer),
                  }}
                  color='primary'
                  showLoader={showLoader}
                  isBroadband
                />
              </Grid>
            ))
          ) : (
            <Box sx={{ height: 300 }}> No Offer Available</Box>
          ))}
        {!md && broadbandData?.length > 3 && (
          <IconButton
            size='small'
            sx={styles(theme).nextArrow}
            onClick={handleRightClick}
            disabled={RightArrowDisabled}
            disableRipple
            disableTouchRipple
          >
            <KeyboardArrowRightIcon />
          </IconButton>
        )}
      </Box>
      {openError && errorModalOccurence > errorModalMaxOccurence && (
        <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
      )}
      {showModal.value && <LoginMain403 />}
      {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
        <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
      )}
      {errorBBModal.value && !showModal.value && !showSessionExpiredModal.value && (
        <ErrorModal
          errorBBModal={errorBBModal}
          occurences={errorModalMaxOccurence}
          currentOccurence={errorModalOccurence}
          ctaMethod={onLoadError ? broadbandOnload : () => {}}
        />
      )}
    </Container>
  );
};

export default MbbOfferCardContainer;
